import callApi from '../../util/apiCaller';

export const ADD_OPPORTUNITY_CONTACT = 'ADD_OPPORTUNITY_CONTACT';
export const ADD_ACCOUNT_CONTACT = 'ADD_ACCOUNT_CONTACT';
export const ADD_OPPORTUNITY_CONTACT_LOAD_ROLES = 'ADD_OPPORTUNITY_CONTACT_LOAD_ROLES';

export function fetchRoles(organizationId) {
  const emptyState = {
    status: null,
    errors: null,
    roles: [],
  };
  return (dispatch) => {
    dispatch({
      ...emptyState,
      type: ADD_OPPORTUNITY_CONTACT_LOAD_ROLES,
      status: 'loading',
      errors: null,
      organizationId,
    });
    const p = new Promise((resolve, reject) => {
      callApi('opportunities/contacts/roles', 'GET').then(
        (roles) => {
          dispatch({
            roles,
            type: ADD_OPPORTUNITY_CONTACT_LOAD_ROLES,
            status: 'loaded',
            errors: null,
            organizationId,
          });
          resolve(roles);
        },
        (errors) => {
          dispatch({
            ...emptyState,
            type: ADD_OPPORTUNITY_CONTACT_LOAD_ROLES,
            status: 'error',
            errors,
            organizationId,
          });
          reject(errors);
        },
      );
    });
    return p;
  };
}

export function addContact(opportunityId, data) {
  return (dispatch) => {
    const p = new Promise((resolve, reject) => {
      callApi(`opportunities/${opportunityId}/contacts`, 'POST', data).then(
        (response) => {
          const { contact } = response;
          dispatch({
            type: ADD_OPPORTUNITY_CONTACT, opportunityId, contact,
          });
          resolve(response);
        },
        (errors) => {
          reject(errors);
        },
      );
    });
    return p;
  };
}

export function addAccountContact(accountId, data) {
  return (dispatch) => {
    const p = new Promise((resolve, reject) => {
      callApi(`accounts/${accountId}/contacts`, 'POST', data).then(
        (contact) => {
          dispatch({
            type: ADD_ACCOUNT_CONTACT, accountId, contact,
          });
          resolve(contact);
        },
        (errors) => {
          reject(errors);
        },
      );
    });
    return p;
  };
}
